import { useWeb3State, useWeb3Actions } from "@/web3/context";
import useWalletSignedFunction from "./useWalletSignedFunction";
import { useCallback } from "react";

const useWithCorrectNetwork = (fn: any) => {
  const { isCorrectChain } = useWeb3State();

  const { toggleNetworkMismatch } = useWeb3Actions();

  const func = useCallback(
    async (arg: any) => {
      if (!isCorrectChain) {
        toggleNetworkMismatch(() => fn(arg));
        return;
      }

      return await fn(arg);
    },
    [fn, isCorrectChain, toggleNetworkMismatch],
  );

  return useWalletSignedFunction(func);
};

export default useWithCorrectNetwork;
